import moment from "moment";
import { TABLE_DATE_FORMAT } from "./Constants";

export const formatTableDate = (value) => {
    if (!value) return "-";

    const timestamp =
        String(value).length === 10
            ? Number(value) * 1000
            : Number(value);

    return moment(timestamp).format(TABLE_DATE_FORMAT);
};
